import { Grid } from "@carbon/react";

export const View = ({ /*fullWidth = false,*/ children, ...rest }) => {
  return <Grid {...rest}>{children}</Grid>;
};
